module.exports = __webpack_public_path__ + "img/vertical_3_7_8011.e09b6a8c.png";